/* ===========================================================
   Lucraa — Landing · Banda de prova/confiança (logo abaixo do hero)
   Sinais HONESTOS, sem escassez fabricada: demonstração ao vivo,
   integração oficial Nuvemshop (somente leitura) e credibilidade do
   maker (Digitalizee). Enhancement futuro: trocar o item 3 por um
   depoimento real de beta.
   =========================================================== */
import { Icon, IntegrationGlyph } from "../../components/ui.jsx";

export function LandingProva() {
  return (
    <section className="lp-prova" aria-label="Confiança">
      <div className="lp-wrap lp-prova-row">
        <div className="lp-prova-item">
          <span className="lp-prova-ic">
            <Icon name="spark" size={17} color="var(--mint)" />
          </span>
          <div>
            <strong>Demonstração ao vivo</strong>
            <span>Veja com os números no porte da sua loja, sem cadastro</span>
          </div>
        </div>
        <div className="lp-prova-item">
          <span className="lp-prova-ic">
            <IntegrationGlyph kind="nuvemshop" size={20} />
          </span>
          <div>
            <strong>Integração oficial Nuvemshop</strong>
            <span>Pela API oficial, em modo somente leitura</span>
          </div>
        </div>
        <div className="lp-prova-item">
          <span className="lp-prova-ic">
            <Icon name="shield" size={17} color="var(--mint)" />
          </span>
          <div>
            <strong>Um produto Digitalizee</strong>
            <span>Analytics de lucro feito no Brasil para Nuvemshop</span>
          </div>
        </div>
      </div>
    </section>
  );
}
